// import { CommonModule } from '@angular/common';
// import { Component, Output, Input, EventEmitter, signal, computed } from '@angular/core';

// @Component({
//   selector: 'app-pagination',
//   imports: [CommonModule],
//   templateUrl: './pagination.component.html',
//   styleUrl: './pagination.component.css'
// })
// export class PaginationComponent {

//   @Input() totalItems: number = 0; // Total number of items
//   @Input() itemsPerPage: number = 10; // Number of items per page

//   @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

//   currentPage = signal(1); // Current page, initialized to 1

//   totalPages = computed(() => Math.ceil(this.totalItems / this.itemsPerPage) || 1); // Total number of pages, at least 1

//   prev()
//   {
//     if (this.currentPage() > 1) {
//       this.currentPage.update(page => page - 1);
//       this.pageChange.emit(this.currentPage());
//     }
//   }

//   next()
//   {
//     if (this.currentPage() < this.totalPages()) {
//       this.currentPage.update(page => page + 1);
//       this.pageChange.emit(this.currentPage());
//     }
//   }
// }

import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  signal,
  computed,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.css'
})
export class PaginationComponent implements OnChanges {

  @Input() totalItems = 0;
  @Input() itemsPerPage = 10;

  @Output() pageChange = new EventEmitter<number>();

  _totalItems = signal(0);
  _itemsPerPage = signal(10);

  currentPage = signal(1);

  totalPages = computed(() =>
    Math.max(1, Math.ceil(this._totalItems() / this._itemsPerPage()))
  );

  ngOnChanges(changes: SimpleChanges) {
    if (changes['totalItems']) {
      this._totalItems.set(changes['totalItems'].currentValue);
      // Reset page when totalItems changes
      this.currentPage.set(1);
      this.pageChange.emit(1);
    }
    if (changes['itemsPerPage']) {
      this._itemsPerPage.set(changes['itemsPerPage'].currentValue);
    }
  }

    visiblePages = computed(() => {
    const total = this.totalPages();
    const current = this.currentPage();
    const delta = 1; // pages around current

    const pages: (number | string)[] = [];

    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const left = Math.max(2, current - delta);
    const right = Math.min(total - 1, current + delta);

    pages.push(1);

    if (left > 2) {
      pages.push('...');
    }

    for (let i = left; i <= right; i++) {
      pages.push(i);
    }

    if (right < total - 1) {
      pages.push('...');
    }

    pages.push(total);

    return pages;
  });

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages()) {
      this.currentPage.set(page);
      this.pageChange.emit(page);
    }
  }
  prev() {
    if (this.currentPage() > 1) {
      this.goToPage(this.currentPage() - 1);
    }
  }

  next() {
    if (this.currentPage() < this.totalPages()) { 
    this.goToPage(this.currentPage() + 1);
  }
}

isNumber(value: number | string): value is number {
  return typeof value === 'number';
}

}
